<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';
import { useMessageMasking } from 'shared/composables/useMessageMasking';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS, MESSAGE_TYPES } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant, inboxId, messageType } = useMessageContext();
const { maskText } = useMessageMasking(inboxId);

// Mascara o texto CRU antes de formatar/sanitizar (deterrente visual).
const maskedContent = computed(() =>
  maskText(props.content, {
    isOutgoing: messageType.value === MESSAGE_TYPES.OUTGOING,
  })
);

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return maskedContent.value;
  }

  return new MessageFormatter(maskedContent.value).formattedMessage;
});
</script>

<template>
  <span v-dompurify-html="formattedContent" class="prose prose-bubble" />
</template>
